import React, { useEffect, useState } from 'react';
import { AlertTriangle, CheckCircle2, X } from 'lucide-react';
import styles from './BasketPolicyDialog.module.css';

const DEFAULT_RULES = [
  'Одна физическая корзина предназначена только для одного этапа.',
  'Сначала измените этап оборудования в CRM.',
  'Только после успешного перехода перекладывайте аппарат физически.',
];

const BasketPolicyDialog = () => {
  const [details, setDetails] = useState(null);

  useEffect(() => {
    const handleConflict = (event) => setDetails(event.detail || {});
    window.addEventListener('basket-stage-conflict', handleConflict);
    return () => window.removeEventListener('basket-stage-conflict', handleConflict);
  }, []);

  if (!details) return null;
  const rules = Array.isArray(details.policy) && details.policy.length ? details.policy : DEFAULT_RULES;

  return (
    <div className={styles.overlay} role="presentation" onMouseDown={(event) => event.target === event.currentTarget && setDetails(null)}>
      <div className={styles.dialog} role="alertdialog" aria-modal="true" aria-labelledby="basket-policy-title">
        <button type="button" className={styles.close} onClick={() => setDetails(null)} aria-label="Закрыть"><X size={20} /></button>
        <div className={styles.icon}><AlertTriangle size={28} /></div>
        <h2 id="basket-policy-title">{details.title || 'В одной корзине нельзя смешивать этапы'}</h2>
        <p className={styles.message}>{details.error}</p>
        <div className={styles.rules}>
          <strong>Как работать с корзинами</strong>
          {rules.map((rule) => <div key={rule}><CheckCircle2 size={18} /><span>{rule}</span></div>)}
        </div>
        <button type="button" className={styles.confirm} onClick={() => setDetails(null)}>Понятно</button>
      </div>
    </div>
  );
};

export default BasketPolicyDialog;
